import { render } from "./DMSClaims.vue?vue&type=template&id=92d0f466&scoped=true"
import script from "./DMSClaims.vue?vue&type=script&lang=js"
export * from "./DMSClaims.vue?vue&type=script&lang=js"

import "./DMSClaims.vue?vue&type=style&index=0&id=92d0f466&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d0f466"]])

export default __exports__